import { useDispatch, useSelector } from 'react-redux'
import { pdfFileSelector } from 'apps/studio/store/selectors/pdf'
import { activeModeSelector } from 'apps/studio/store/selectors/studioSettings'
import { entriesSelector } from 'apps/formsCreationKit/store/selectors/entities'
import { studioSettingsActions } from 'apps/studio/store/reducers/settings/studioSettings'
const { setActiveMode } = studioSettingsActions

import { GlassBackgroundEffect } from 'apps/studio/components/shared/GlassEffect'
import { PdfIcon, TestIcon } from '@gocanvas/gcds/icons'
import { GCDSSwitcher } from '@gocanvas/gcds/components'

export const WorkspaceSwitcher = () => {
  const dispatch = useDispatch()
  const hasPdf = useSelector(pdfFileSelector)
  const entries = useSelector(entriesSelector)
  const activeMode = useSelector(activeModeSelector)

  const workspaceToggleOptions = [
    { value: 'PDF', label: 'PDF', IconComponent: PdfIcon },
    {
      value: 'Test',
      label: 'Test',
      IconComponent: TestIcon,
      disabled: entries.length === 0,
    },
  ]

  return (
    <GlassBackgroundEffect className="header-section header-middle">
      {hasPdf && (
        <GCDSSwitcher
          name={`workspace-switcher`}
          options={workspaceToggleOptions}
          value={activeMode}
          onChange={val => dispatch(setActiveMode({ activeMode: val }))}
        />
      )}
    </GlassBackgroundEffect>
  )
}
